<template>
  <el-form-item :prop="prop" v-if="!disabled" :error="error">
    <slot></slot>
  </el-form-item>
  <el-form-item v-else :error="error">
    <slot></slot>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * 非活性指定時はバリデーション判定から外すElFormItemラッパーコンポーネント
 */
export default defineComponent({
  props: {
    prop: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    error: {
      type: String,
      required: false,
    },
  },
})
</script>
